export const defaultFont = `'Roboto', sans-serif`
export const headersFont = `'Poppins', sans-serif`


// WEBPACK FOOTER //
// ./src/pages/ForInvestors/consts/index.jsx